
import axios from 'axios'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_HTTP_URL || "http://182.92.73.6:9001",
  timeout: 15000 // request timeout
})

// request interceptor
service.interceptors.request.use(config => {
  return config
}, error => {
  Promise.reject(error)
})

/* 请求统一处理：404、500、token失效等 */
service.interceptors.response.use(response => {

  return response
}, error => {
  // TODO 异常
  Promise.reject(error)
})

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js